import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment";
import { timeout, tap, map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch'
import { BBResponseContainer } from '../common-services/response-container';
import { UpdateBatchDateAndTimeDTO } from './model/updateBatchDateAndTimeDTO';


@Injectable()
export class APGAdministrationService {
  defaultTimeout = 600000;
  
  constructor(private http: HttpClient) {
  }
  
  redoBatchService(batch: Covid19Batch): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/redo";
    return this.http.put<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  
  changeBatchStatus(batch: Covid19Batch): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/status";
     return this.http.put<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
       error.url = url;
      }));
    }
  
  getBatchForLabAndBatchId(labId: string, fieldName: string , value: string): Observable<BBResponseContainer> {
    
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch";
    let requestParam = new HttpParams().set('lab', labId).set('fieldName', fieldName).set('value', value);

    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  fetchSampleInfo(selectedLabId: string, searchID: string): Observable<BBResponseContainer>  {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/sample/search/" + selectedLabId + "/" + searchID;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
  }
  
  deleteSampleFromBatch(selectedLabId: string, sampleBarcode: string, batchIdToDeleteSample: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/sample/remove?lab=" + selectedLabId + '&sampleBarcode=' + sampleBarcode;
    if(batchIdToDeleteSample)
    url = url + "&batchId=" + batchIdToDeleteSample;
    return this.http.put<BBResponseContainer>(url, '').pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  
  removeBatch(labId: string, batchId: string,workflow:string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/remove/" + labId  + '/' + batchId+'/' + workflow;
    return this.http.put<BBResponseContainer>(url,'').pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  
  changeFalseRedo(labId: string, covidBatch: Covid19Batch, redoCount: number) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/falseredo/" + labId + '/' + redoCount;
    return this.http.put<BBResponseContainer>(url, covidBatch).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  
  removeUnnecessaryRedo(labId: string, selectedBatchIdToComplete: string, batchIdsTobeRemoved: string[]) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/unnecessaryredo/" + labId + '/' + selectedBatchIdToComplete;
    return this.http.put<BBResponseContainer>(url, batchIdsTobeRemoved).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  
  submitOrder(request): Observable<BBResponseContainer>{
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"api/shipping";
    return this.http.post<BBResponseContainer>(url, request).pipe(timeout(environment.defaultTimeout), tap(event => error => {
      error.url = url;
    }));
  }
  
  
  submitEvent(request): Observable<BBResponseContainer>{
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"mockEvent/receiveMessage";
    return this.http.post<BBResponseContainer>(url, request).pipe(timeout(environment.defaultTimeout), tap(event =>  error => {
      error.url = url;
    }));
  }
  
  getSampleOrderStatus(id): Observable<BBResponseContainer> {
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"api/shipping/status/order/"+id;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => error => {
      error.url = url;
    }));
  }
  
  updateBatchTime(selectedBatch: UpdateBatchDateAndTimeDTO): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/updateStatusDateTime";
    return this.http.patch<BBResponseContainer>(url, selectedBatch).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
  
  downloadTemplate(downloadType: string) {
    let request = {'downloadType' : downloadType, 'requestParam': null}
    return this.http.put(environment.BB_NGS_RUN_PLANNING_URL + 'api/excel/download', request, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        let data = {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
        return data;
      }), catchError(error => throwError(null))
    );
  }
  
  uploadCSVForLibraryUpdate(formData: FormData) {
    let url = environment.BB_NGS_RUN_PLANNING_URL + "api/file/upload";
    return this.http.post<any>(url, formData).pipe(timeout(this.defaultTimeout));
  }

  updateRun(request: any): Observable<any> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + 'runplan/updateRunDetails';
    return this.http.patch<any>(url, request).pipe(timeout(environment.defaultTimeout));
  }

  getOverlapRuns(request: any): Observable<any> {
    let url = environment.BB_NGS_RUN_PLANNING_URL + 'runplan/overLapList';
    return this.http.put<any>(url, request).pipe(timeout(environment.defaultTimeout));
  }
  fetchDeliveryInfo(deliveryId: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL+"delivery?delivery="+deliveryId
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }

  fetchOrder(deliveryId: string, sampleId: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL+"order/"+sampleId+"?delivery="+deliveryId
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }
  fetchInvoicedOrders(fromDate: string, untilDate: string){
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL+"dateRange?from="+fromDate+"&until="+untilDate;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }
  
  fetchOrderBySampleID(sampleId: string): Observable<BBResponseContainer> {
    let url = environment.BB_ANIMAL_ORDER_SERVICE_URL+"/api/shipping/orders/"+sampleId;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => {
      /* */
    }, error => {
      error.url = url;
    }));
  }
}
